"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var react_1 = require("react");
var composable_validation_1 = require("composable-validation");
function getValueFromEvent(e) {
    // support elements which just return their value
    if (!e || !e.target) {
        return e;
    }
    return e.target.type === 'checkbox' ? e.target.checked : e.target.value;
}
exports.getValueFromEvent = getValueFromEvent;
exports.withForm = function (config) {
    return function (WrappedComponent) {
        return _a = /** @class */ (function (_super) {
                __extends(FormWrappedComponent, _super);
                function FormWrappedComponent(props) {
                    var _this = _super.call(this, props) || this;
                    _this.cachedEventHandlers = {};
                    _this.controlProxy = new Proxy({}, { get: function (_, name) { return _this.controlFor(name); } });
                    _this.validationErrors = function (fieldMeta) {
                        return lodash_1.pickBy(lodash_1.mapValues(fieldMeta, function (meta) {
                            return ((meta != null && meta.hasBlurred) ? (meta.errors) : composable_validation_1.valid);
                        }), function (errors) { return errors && errors.length > 0; });
                    };
                    _this.ifValid = function (callbackIfValid) {
                        var validator = config.validator && config.validator(_this.props)(_this.state.values);
                        var validationResult = composable_validation_1.validate((validator || {}), _this.state.values);
                        if (!composable_validation_1.hasValidationErrors(validationResult)) {
                            callbackIfValid(_this.state.values);
                        }
                        else {
                            // Mark all fields as blurred so that validation errors are shown
                            _this.setState(function (currentState) { return ({
                                fieldMeta: lodash_1.mapValues(currentState.fieldMeta, function (_a) {
                                    var errors = _a.errors;
                                    return ({ errors: errors, hasBlurred: true });
                                }),
                                values: currentState.values,
                            }); });
                        }
                    };
                    _this.onSubmit = function (event) {
                        event.preventDefault();
                        _this.ifValid(config.onSubmit(_this.props));
                    };
                    _this.controlFor = function (fieldName) {
                        if (_this.cachedEventHandlers[fieldName] == null) {
                            _this.cachedEventHandlers[fieldName] = {
                                // Typescript complains when using object spread on a generic type, use assign to work around.
                                onBlur: function () { return _this.setState(function (currentState) {
                                    return ({
                                        fieldMeta: Object.assign({}, currentState.fieldMeta, (_a = {},
                                            _a[fieldName] = Object.assign({}, currentState.fieldMeta[fieldName], { hasBlurred: true }),
                                            _a)),
                                        values: currentState.values,
                                    });
                                    var _a;
                                }); },
                                onChange: function (event) {
                                    var newValue = getValueFromEvent(event);
                                    _this.setState(function (currentState) {
                                        var nextValues = Object.assign({}, currentState.values, (_a = {}, _a[fieldName] = newValue, _a));
                                        var validatorInstance = config.validator && config.validator(_this.props)(nextValues);
                                        var validationResult = composable_validation_1.validate((validatorInstance || {}), nextValues);
                                        var nextFieldMeta = lodash_1.mapValues(currentState.fieldMeta, function (currentFieldMeta, keyFieldName) { return Object.assign({}, currentFieldMeta, {
                                            errors: validationResult[keyFieldName],
                                        }); });
                                        return {
                                            fieldMeta: nextFieldMeta,
                                            values: nextValues,
                                        };
                                        var _a;
                                    });
                                },
                            };
                        }
                        var value = _this.state.values[fieldName];
                        var props = Object.assign({}, _this.cachedEventHandlers[fieldName], {
                            value: value,
                        });
                        return function (control) {
                            var _a = control.props, existingOnChange = _a.onChange, existingProps = __rest(_a, ["onChange"]);
                            var newOnChange = existingOnChange == null
                                ? props.onChange
                                : function (fieldValue) {
                                    existingOnChange(fieldValue);
                                    if (props.onChange != null) {
                                        props.onChange(fieldValue);
                                    }
                                };
                            var enhancedProps = __assign({}, existingProps, props, { onChange: newOnChange });
                            return react_1.cloneElement(control, enhancedProps);
                        };
                    };
                    var values = config.initialValues(props);
                    var initialValidator = (config.validator && config.validator(props)(values)) || {};
                    var initialValidationResult = composable_validation_1.validate(initialValidator, values);
                    var fieldMeta = lodash_1.mapValues(values, function (value, fieldName /*K*/) { return ({
                        errors: initialValidationResult[fieldName] || [],
                        hasBlurred: false,
                    }); });
                    _this.state = { fieldMeta: fieldMeta, values: values };
                    return _this;
                }
                FormWrappedComponent.prototype.render = function () {
                    var hasUserVisibleValidationErrors = lodash_1.some(this.state.fieldMeta, function (fm) { return fm.hasBlurred && fm.errors && fm.errors.length > 0; });
                    var formProps = {
                        form: {
                            controlFor: this.controlProxy,
                            hasValidationErrors: hasUserVisibleValidationErrors,
                            ifValid: this.ifValid,
                            // setValues: (values: Partial<FM>) => console.log(values), // TODO
                            submit: this.onSubmit,
                            validationErrors: this.validationErrors(this.state.fieldMeta),
                            values: this.state.values,
                        }
                    };
                    var enhancedProps = Object.assign({}, this.props, formProps);
                    return react_1.createElement(WrappedComponent, enhancedProps);
                };
                return FormWrappedComponent;
            }(react_1.Component)),
            _a.displayName = "withForm(" + (WrappedComponent.displayName || WrappedComponent.name) + ")",
            _a;
        var _a;
    };
};



//////////////////
// WEBPACK FOOTER
// ../with-form/dist/withForm.js
// module id = 47
// module chunks = 0